import { ADMINISTRATION_STATUSES } from 'services/administrations/constants'

export const ADMINISTRATION_STATUS_COLORS = {
  [ADMINISTRATION_STATUSES.ADMINISTERED]: '#098609',
  [ADMINISTRATION_STATUSES.MISSED]: '#E20714',
  [ADMINISTRATION_STATUSES.SIGNED]: '#36A9E0',
}
